import {CommonModule} from '@angular/common';
import {Component, EventEmitter, HostListener, OnDestroy, OnInit, Output} from '@angular/core';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ApiService} from '../../services/api.service';
import {
  faAngleRight,
  faAngleUp,
  faBell,
  faCamera,
  faGear,
  faPowerOff,
  faRotateRight,
  faUpRightFromSquare,
  faUser
} from '@fortawesome/free-solid-svg-icons';
import {NavigationEnd, Router} from '@angular/router';
import {Subject} from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';
import {AuthService} from '../../services/auth.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    imports: [CommonModule, FontAwesomeModule]
})
export class HeaderComponent  implements OnInit, OnDestroy{
  dropdownOpen = false;
  notificationOpen = false;
  notificationData: any = []
  isSeeAllNotification = false

  @Output() toggle = new EventEmitter<void>();

  @Output() headerNavClick = new EventEmitter<string>();

  private readonly destroy$ = new Subject<void>();

  currentPageTitle: string = ''; // default

  

   constructor(private router: Router,
                library: FaIconLibrary,
               private apiService: ApiService,
               private authService: AuthService,
    ) {
      library.addIcons(faUser, 
                      faRotateRight, 
                      faGear,
                      faBell,
                      faUpRightFromSquare,
                      faPowerOff,
                      faAngleRight,
                      faAngleUp,
                      faCamera
                      )
   }
  ngOnInit() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {

        const currentUrl = this.router.url;
        if (['/vehicle', '/add-vehicle', '/vehicle/bulk'].includes(currentUrl)) {
          this.currentPageTitle = 'Vehicle Database';
        } else if (currentUrl.includes('/track')) {
          this.currentPageTitle = 'Track Vehicle';
        } else if (currentUrl.includes('/reports')) {
          this.currentPageTitle = 'Reports';
        } else if (currentUrl.includes('/admin/contact-us-requests')) {
            this.currentPageTitle = 'Customer Enquiries';
        }  else if (currentUrl.includes('/contact-us')) {
          this.currentPageTitle = 'Help & Support';
        } else if (currentUrl.includes('/events')) {
          this.currentPageTitle = 'Events';
        } else if (currentUrl.includes('/profile')) {
          this.currentPageTitle = 'Profile';
        }else if (currentUrl.includes('/organization')) {
          this.currentPageTitle = 'Organization';
        }  else {
          this.currentPageTitle = '';
        }
      });
  }

  toggleNotifications() {
      this.apiService.notifications().subscribe({
        next: (data: any) => {
          this.notificationData = data
  
        }, error: (err) => {
  
        }
      })
      this.notificationOpen = !this.notificationOpen
      this.isSeeAllNotification = false
      
    }
    seeAllNotifications(){
      this.isSeeAllNotification = !this.isSeeAllNotification
    }
  
    getRelativeTime(dateString: string): string {
      const date = new Date(dateString);
      const now = new Date();
      const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);
      
      if (seconds < 60) return 'just now';
      if (seconds < 3600) return Math.floor(seconds / 60) + ' minutes ago';
      if (seconds < 86400) return Math.floor(seconds / 3600) + ' hours ago';
      if (seconds < 604800) return Math.floor(seconds / 86400) + ' days ago';
      if (seconds < 2419200) return Math.floor(seconds / 604800) + ' weeks ago';
      return Math.floor(seconds / 2419200) + ' months ago';
    }
  
    profilePage(){
      this.headerNavClick.emit('profile');
      this.router.navigate(["profile"]);
      this.dropdownOpen = false;
      
    }
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    }
    changePassword(){
      // this.headerNavClick.emit('change-password');
      // this.router.navigate(['change-password']);
      this.headerNavClick.emit('settings');
      this.router.navigate(['settings']);
      this.dropdownOpen = false;
    }
  
    @HostListener('document:click', ['$event'])
    clickOutside(event: Event) {
      const target = event.target as HTMLElement;
      const dropdownElement = document.querySelector('.dropdown');
      if (dropdownElement && !dropdownElement.contains(target)) {
        this.dropdownOpen = false;
      }
      const notificationElement = document.querySelector('.notification');
      if (notificationElement && !notificationElement.contains(target)) {
        this.notificationOpen = false;
      }
    }
  
    logout(){
        // P22-08 L2: centralized hard logout + cross-tab invalidation.
        this.authService.logout('header-logout');
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
}
